import { v4 as uuidv4 } from 'uuid';

export function ModalTrigger(props, childrenComponents = []) {
	return {
		componentName: 'ModalTrigger',
		componentId: uuidv4(),
		props: Object.assign(
			{
				trigger: 'click',
				customPixelEventId: '',
				customPixelEventName: '',
			},
			props,
		),
		childrenComponents,
	};
}
